import { ADMISSION_TYPE_BOTTLE_SERVICE, ADMISSION_TYPE_TICKET } from '@domain/admission';
import { type VatRates } from '@hooks/company/use-get-company-vat-rates';

import { type AdmissionFormType } from '../admission-form.type';
import { ADMISSION_FORM_TYPE_PASS } from '../constants';

const companyRateForType = (companyVatRates: VatRates, type: AdmissionFormType): number | null => {
  switch (type) {
    case ADMISSION_TYPE_TICKET:
      return companyVatRates.ticketVatRate;
    case ADMISSION_TYPE_BOTTLE_SERVICE:
      return companyVatRates.bottleServiceVatRate;
    case ADMISSION_FORM_TYPE_PASS:
      return companyVatRates.passVatRate;
    default:
      return null;
  }
};

export interface ResolveVatRateParams {
  companyVatRates?: VatRates;
  offer?: { vatRate?: number | null } | null;
  type: AdmissionFormType;
  isCreatedFromPreset?: boolean;
}

export const resolveInitialVatRate = ({
  companyVatRates,
  offer,
  type,
  isCreatedFromPreset,
}: ResolveVatRateParams): number | null => {
  if (!offer) {
    return companyVatRates ? companyRateForType(companyVatRates, type) : null;
  }

  if (isCreatedFromPreset) {
    if (offer.vatRate != null) return offer.vatRate;
    return companyVatRates ? companyRateForType(companyVatRates, type) : null;
  }

  return offer.vatRate ?? null;
};
